import { render, staticRenderFns } from "./RCMLiveStatus.vue?vue&type=template&id=2c5878b8&scoped=true"
import script from "./RCMLiveStatus.vue?vue&type=script&lang=js"
export * from "./RCMLiveStatus.vue?vue&type=script&lang=js"
import style0 from "./RCMLiveStatus.vue?vue&type=style&index=0&id=2c5878b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5878b8",
  null
  
)

/* custom blocks */
import block0 from "./RCMLiveStatus.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports